import { render } from "./StockReportPage.vue?vue&type=template&id=68daa8e7&scoped=true&ts=true"
import script from "./StockReportPage.vue?vue&type=script&lang=ts"
export * from "./StockReportPage.vue?vue&type=script&lang=ts"

import "./StockReportPage.vue?vue&type=style&index=0&id=68daa8e7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68daa8e7"]])

export default __exports__